import {recursiveWalker} from "@/includes/parse_psd_data";
import {PARSED_FIELD_TYPES, PSD_LAYERS_DATA_TYPES} from "@/includes/parse_psd_data/constants";
import {EVENTS as PSD_LAYERS_EVENT, psdLayersEventBroker} from "./event-broker";

export const extractLayersFromTree = tree => {
    const layers = []

    recursiveWalker(tree, node => {
        if (!PSD_LAYERS_DATA_TYPES.includes(node.type) || !node.visible) {
            return;
        }

        layers.push(node)
    })

    return layers
}

export const extractGroupsFromTree = tree => {
  const groups = []

  recursiveWalker(tree, node => {
    if (node.type !== PARSED_FIELD_TYPES.FOLDER || !node.visible) {
      return;
    }

    const { children, ...group } = node;

    groups.push(group);
  })

  return groups
}

export const filterLayersByTemplate = (layers, template) => layers.filter(layer => template.fields.find(field => field.uuid === layer.uuid))

export const multipleTemplateHandler = (callback, postHandler) => async ({ files, options }) => {
    const _files = Array.isArray(files) ? files : [files];
    psdLayersEventBroker.fire(PSD_LAYERS_EVENT.IMPORT_PROGRESS, { completed: 0, total: _files.length });

    for (const [fileIndex, file] of _files.entries()) {
        for (const template of file.templates) {
            const data = {
                ...file,
                template,
                layers: !file.isImportWithoutLayers
                  ? filterLayersByTemplate(file.layers, { fields: extractLayersFromTree(template.children) })
                  : file.layers,
                groups: file.isGroupGroupedLayers ? extractGroupsFromTree(template.children) : [],
            };

            await callback(data);
        }
        psdLayersEventBroker.fire(PSD_LAYERS_EVENT.IMPORT_PROGRESS, { completed: fileIndex + 1, total: _files.length });
    }

    postHandler(options)
}

export const getOptionsFromLibraryModal = () => {
    let options = {}

    try {
        options = JSON.parse($('#selectBkImgModal').data('options'))
    } catch (error) {
        console.error('No options in file browser modal provided')
    }

    return options
}
